export function LoadingSpinner() {
  return (
    <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto'></div>
  )
}

interface LoadingStateProps {
  message?: string
  className?: string
}

/**
 * Consistent loading state component used across the app.
 * Use this for all loading indicators to maintain visual consistency.
 */
export function LoadingState({ message = 'Loading...', className = 'h-full' }: LoadingStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 select-none ${className}`}>
      <LoadingSpinner />
      <p className='text-gray-600 select-none'>{message}</p>
    </div>
  )
}
